export default __webpack_public_path__ + "static/media/REST_API.87e03fa0.jpg";